<template>
    <div class="MyOrder">
        <div class="MyOrderBox">
            <div class="Img" v-if="requestNums > 0" style="padding: 8px">
			  <el-collapse accordion>
				<el-collapse-item>
				  <template slot="title">
					<el-badge :value="requestNums" class="item">
					  <div style="font-size: 16px;color: #2c3e50">您有新的授权请求待处理！</div>
					</el-badge>
				  </template>
				
				<el-alert style="margin-bottom: 16px; padding: 7px 16px;" title="报告授权请求，请与授权请求人核实后再确认是否授权" type="warning" ></el-alert>
				<el-table :data="MyRequestList" :header-cell-style="HeaderCellStyle" :cell-style="CellStyle" v-loading="listLoading"  border style="width: 100%;">
					<el-table-column prop="authorizeRequestor" label="授权请求人" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="reportNo" label="报告编号" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="wtdwmc" label="委托单位" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="confirmTime" label="报告日期" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
				  <el-table-column  label="授权报告" min-width="20%" :show-overflow-tooltip="true">
					<template slot-scope="scope">
					  <div style="float: left;margin-right: 10px">
						<el-button type="primary" size="small" style="background-color: #409eff; border-color: #409eff;" @click="agreeAuthorize(scope.row)">同意授权</el-button>
					  </div>
					  <div style="float: left">
						<el-button type="danger" size="small"  @click="refuseAuthorize(scope.row)">拒绝授权</el-button>
					  </div>
					</template>
				  </el-table-column>
				  <el-table-column label="查看报告" min-width="20%" :show-overflow-tooltip="true">
					<template slot-scope="scope">
					  <div>
						<el-button type="primary" size="small" @click="reportView(scope.row)">查看报告</el-button>
					  </div>
					</template>
				  </el-table-column>
					</el-table>
				</el-collapse-item>
			  </el-collapse>
            </div>
            <!-- 查询 -->
            <el-form :inline="true" :model="MyAuthorizeForm" style="text-align: left;margin-top: 15px" class="demo-form-inline">
                <el-form-item label="报告编号：" style="margin-right: 30px;">
					<el-input v-model="MyAuthorizeForm.reportNo" ></el-input>
                </el-form-item>
                <el-form-item label="报告日期：" style="margin-right: 30px;">
                    <el-date-picker 
                        v-model="date"
                        @change="handleChangeDate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                        :picker-options="pickerOptions"
                        unlink-panels></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜 索</el-button>
                </el-form-item>
            </el-form>
            <!-- table -->
            <el-table :data="MyAuthorizeList" :header-cell-style="HeaderCellStyle" :cell-style="CellStyle" v-loading="listLoading" height="655" border style="width: 100%;">
                <el-table-column prop="reportNo" label="报告编号" min-width="15%" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="wtdwmc" label="委托单位" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="confirmTime" label="报告日期" min-width="15%" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="authorizeTime" label="授权日期" min-width="15%" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="state" label="授权报告" min-width="20%" :show-overflow-tooltip="true">
				  <template slot-scope="scope">
					<div v-if="scope.row.state === 0&&scope.row.stateName === '未发起'">
					  <el-button type="primary" size="small" style="background-color: #409eff; border-color: #409eff;" @click="reportAuthorize(scope.row)">授权报告</el-button>
					</div>
					<div v-else-if="scope.row.state === 15&&scope.row.authorizePerson !== scope.row.authorizeRequestor">
					  {{scope.row.stateName + '(请求人：'+scope.row.authorizeRequestor+')' }}
					</div>
					<div v-else>
					  {{scope.row.stateName}}
					</div>
				  </template>
				</el-table-column>
                <el-table-column label="操作" min-width="15%" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="primary" size="small" @click="reportView(scope.row)">查看报告</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <!--  v-loading="listLoading" -->
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="MyAuthorizeForm.currentPage"
                    background
                    :page-size="MyAuthorizeForm.pageSize"
                    layout="total, prev, pager, next"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="total">
                </el-pagination>
            </div>
        </div>
		<el-dialog
			title="查看报告"
			:visible.sync="dialogVisible"
			width="60%"
			:before-close="handleClose">
			<span>
			  <img :src="reportUrl" />
			</span>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
		  </span>
		</el-dialog>
    </div>
</template>

<script>
import * as API from '@/api/authorize';
import { getCommonToken } from '@/utils/auth';
export default {
    name: 'MyAuthorize',
    components: {
    
    },
    data() {
        return {
			MyAuthorizeForm: {
                pageSize: 10,
                currentPage: 1
            },
            StatusOptions: [
                { label: '全 部', value: '' },
                { label: '待支付', value: '10' },
                { label: '处理中', value: '15' },
                { label: '待发货', value: '20' },
                { label: '已发货', value: '25' },
                { label: '已完成', value: '30' },
                { label: '已取消', value: '50' }
            ],
            // 时间
            date: [],
            // tableList
            MyAuthorizeList: [],
		    MyRequestList:[],
            total: 0,
            listLoading: false,
		    listRequestLoading:false,
		    dialogVisible:false,
		    reportUrl:'',
		    requestNums:0
        }
    },
    methods: {
        // 查询
        handleSearch() {
            this.GetList();
        },
        // 同意授权
	    agreeAuthorize(row) {
            this.$confirm('是否同意授权此报告给海尔SQM?', '授权确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                API.agreeAuthorize(row.reportId).then(res => {
                    if (res.code === 20000) {
                        this.$message({ type: 'success', message: '授权成功!'});
                        this.GetList();
                        this.GetRequestList()
                    }
                })
            }).catch(() => {});
        },
		// 拒绝授权
	     refuseAuthorize(row) {
		  this.$confirm('是否拒绝授权?', '授权确认', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		  }).then(() => {
			API.refuseAuthorize(row.reportId).then(res => {
			  if (res.code === 20000) {
				this.$message({ type: 'success', message: '拒绝成功!'});
				this.GetList();
				this.GetRequestList()
			  }
			})
		  }).catch(() => {});
		},
		// 授权报告
		reportAuthorize(row) {
		  this.$confirm('是否授权此报告给海尔SQM?', '授权确认', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		  }).then(() => {
			API.reportAuthorize(row.reportId).then(res => {
			  if (res.code === 20000) {
				this.$message({ type: 'success', message: '授权成功!'});
				this.GetList();
				this.GetRequestList()
			  }
			})
		  }).catch(() => {});
		},
		// 查看报告
		reportView(row) {
          this.getViewUrl(row.draftDocumentId);
		},
		handleClose(){
		  this.dialogVisible=false
		  this.reportUrl = ''
		},
	    getViewUrl(docId){
		  API.getViewUrl(docId).then(res => {
			this.reportUrl = res.data
		    console.info(this.reportUrl)
			window.open(res.data, '_blank')
		  }).catch(() => {
			
		  });
		},
        // 报告时间
        handleChangeDate(val) {
            if(val) {
                this.$set(this.MyAuthorizeForm, 'reportStarttime', val[0] + ' 00:00:00');
                this.$set(this.MyAuthorizeForm, 'reportEndtime', val[1]+ ' 23:59:59');
            } else {
                this.$set(this.MyAuthorizeForm, 'reportStarttime', null);
                this.$set(this.MyAuthorizeForm, 'reportEndtime', null);
            }
        },
        // 分页改变
        handleCurrentChange(val) {
            this.MyAuthorizeForm.currentPage = val;
            this.GetList();
        },
        // 获取报告列表
        GetList() {
            this.listLoading = true;
            this.$set(this.MyAuthorizeForm, "xdkh", getCommonToken("MOBILE"));
            API.getMyReportList(this.MyAuthorizeForm).then(res => {
                this.listLoading = false;
                if(res.code === 20000) {
                    this.MyAuthorizeList = res.data.datas;
                    this.total = res.data.totalRecord;
                }
            }).catch(() => {
                this.listLoading = false;
            });
        },
	  // 获取请求列表
		GetRequestList() {
		  this.listRequestLoading = true;
		  this.$set(this.MyAuthorizeForm, "xdkh", getCommonToken("MOBILE"));
		  API.getReportAuthorizeList().then(res => {
			this.listRequestLoading = false;
			if(res.code === 20000) {
			  this.MyRequestList = res.data;
			  this.requestNums = res.data.length
			}
		  }).catch(() => {
			this.listRequestLoading = false;
		  });
		},
        // 0  待处理  15  授权成功   20 对方拒绝授权
        GetStatus(status) {
            let str;
            switch(status) {
                case 0:
                    str = "待处理";
                    break;
                case 15:
                    str = "授权成功";
                    break;
                case 20:
                    str = "已拒绝对方授权申请";
                    break;
            }
            return str;
        },
        // 表头
        HeaderCellStyle () {
            // console.log(row, column, rowIndex, columnIndex);
            return 'text-align: center; color: #ffffff; background: #3880ca;';
        },
        // 单元格
        CellStyle () {
            // console.log(row, column, rowIndex, columnIndex);
            return 'text-align: center; color: #000000;';
        }
    },
    mounted() {
        console.log("Mobile", getCommonToken("MOBILE"))
        this.GetList();
        this.GetRequestList()
    }
}
</script>

<style scoped>
.MyOrder {
    margin-top: 12px;
    overflow: hidden;
    margin-bottom: 200px;
}
.MyOrder .MyOrderBox {
    width: 100%;
    margin: 0 auto;
}
.MyOrder .MyOrderBox .Img {
    margin-top: 30px;
    overflow: hidden;
    text-align: left;
    margin-bottom: 60px;
}
.MyOrder .MyOrderBox /deep/ .el-form--inline .el-form-item__label {
    font-weight: 600;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox {
    overflow: hidden;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .image {
    width: 58px;
    height: 58px;
    float: left;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .image img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info {
    float: left;
    width: 292px;
    overflow: hidden;
    text-align: left;
    margin-left: 16px;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info .title {
    font-weight: 600;
    margin-bottom: 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info .desc {
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder .MyOrderBox .page {
    text-align: right;
    margin-top: 20px;
}
.MyOrder .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-next, 
.MyOrder .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-prev {
  padding: 0 5px;
}
</style>